import React from "react";
import { Modal, Button, Typography } from "antd";

function QuickWordDeleteDialog({
  open,
  onClose,
  selectedCommand,
  onDelete,
  isProcessing,
}) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Delete Command"
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={onDelete}
          disabled={isProcessing === "delete"}
          loading={isProcessing === "delete"}
        >
          Delete
        </Button>,
      ]}
    >
      <Typography.Text>
        Are you sure you want to delete the command &quot;
        {selectedCommand?.id}&quot;? This action cannot be undone.
      </Typography.Text>
    </Modal>
  );
}

export default QuickWordDeleteDialog;
